import { useEffect, useState } from "react";
import { AxiosPublico } from "../../../componentes/axios/Axios";
import Card from "../../../componentes/contenedores/Card";
import Linea from "../../../componentes/graficos/Lineal2";
import Page from "../../../componentes/plantilla/Page";
import {
    HistorialesHumedadRelativaListar,
    HistorialesIluminacionListar,
    HistorialesSueloListar,
    HistorialesTemperaturaListar,
} from "../../../configuracion/apiUrls";
import ResumenMinMax from "./Historiales/ResumenMinMax";

// Definimos las URLs y los títulos de los sensores
const urls = [
    { url: HistorialesHumedadRelativaListar, titulo: "Humedad Relativa", tipo: "humedadRelativa" },
    { url: HistorialesTemperaturaListar, titulo: "Temperatura", tipo: "temperatura" },
    { url: HistorialesSueloListar, titulo: "Humedad del Suelo", tipo: "suelo" },
    { url: HistorialesIluminacionListar, titulo: "Iluminación", tipo: "iluminacion" },
];

const coloresPorTipo = {
    humedad: "#36A2EB",
    humedadRelativa: "#4BC0C0",
    temperatura: "#FF6384",
    suelo: "#FFCE56",
    iluminacion: "#9966FF",
};

const ComparacionGraficas = () => {
    const [cargando, setCargando] = useState(false);
    const [dataComparacion, setDataComparacion] = useState({});

    // Estados para los filtros y las selecciones
    const [sensorUrl, setSensorUrl] = useState(HistorialesHumedadRelativaListar);

    // Estados para el Período A
    const [filtroA, setFiltroA] = useState("dia");
    const [fechaSeleccionadaA, setFechaSeleccionadaA] = useState(new Date().toLocaleDateString('en-CA'));
    const [semanaSeleccionadaA, setSemanaSeleccionadaA] = useState("");
    const [mesSeleccionadoA, setMesSeleccionadoA] = useState(new Date().toISOString().slice(0, 7));
    const [anioSeleccionadoA, setAnioSeleccionadoA] = useState(new Date().getFullYear());

    // Estados para el Período B
    const [filtroB, setFiltroB] = useState("dia");
    const [fechaSeleccionadaB, setFechaSeleccionadaB] = useState(new Date().toLocaleDateString('en-CA'));
    const [semanaSeleccionadaB, setSemanaSeleccionadaB] = useState("");
    const [mesSeleccionadoB, setMesSeleccionadoB] = useState(new Date().toISOString().slice(0, 7));
    const [anioSeleccionadoB, setAnioSeleccionadoB] = useState(new Date().getFullYear());

    const datosPagina = {
        titulo: {
            titulo: "Comparar Gráficas",
            url: "/app/admin/invernaderos/",
            tituloUrl: "Menú Principal",
            nombreUrl: "Comparar",
        },
    };

    const formatearDatos = (rawData, label, color, tipo, filtro) => {
        let labels = [];
        let valores = [];
        const titulo = label;

        if (filtro === "dia" || filtro === "semana") {
            const datosFiltradosOrdenados = rawData.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
            labels = datosFiltradosOrdenados.map(item => {
                const fecha = new Date(item.fecha);
                const hours = String(fecha.getHours()).padStart(2, '0');
                const minutes = String(fecha.getMinutes()).padStart(2, '0');
                return `${hours}:${minutes}`;
            });
            valores = datosFiltradosOrdenados.map(item => item.valor);
        } else if (filtro === "mes") {
            const datosPorDia = {};
            rawData.forEach(item => {
                const fecha = new Date(item.fecha).toISOString().split('T')[0];
                if (!datosPorDia[fecha]) {
                    datosPorDia[fecha] = { total: 0, count: 0 };
                }
                datosPorDia[fecha].total += item.valor;
                datosPorDia[fecha].count++;
            });
            const fechasUnicas = Object.keys(datosPorDia).sort();
            labels = fechasUnicas.map(fecha => new Date(fecha).getDate().toString());
            valores = fechasUnicas.map(fecha => datosPorDia[fecha].total / datosPorDia[fecha].count);
        } else if (filtro === "año") {
            const promediosPorMes = Array(12).fill(null);
            const mesesNombres = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
            const datosPorMes = {};
            rawData.forEach(item => {
                const mes = new Date(item.fecha).getMonth();
                if (!datosPorMes[mes]) {
                    datosPorMes[mes] = [];
                }
                datosPorMes[mes].push(item.valor);
            });
            for (const mes in datosPorMes) {
                const valoresDelMes = datosPorMes[mes];
                const promedio = valoresDelMes.reduce((a, b) => a + b, 0) / valoresDelMes.length;
                promediosPorMes[mes] = promedio;
            }
            labels = mesesNombres;
            valores = promediosPorMes;
        }

        const dataset = {
            label: label,
            data: valores,
            borderColor: color,
            backgroundColor: color,
            tension: 0.1,
            fill: false,
            pointRadius: (filtro === "mes" || filtro === "año") ? 3 : 1,
            pointHoverRadius: (filtro === "mes" || filtro === "año") ? 5 : 1,
        };

        return {
            labels,
            datasets: [dataset],
            raw: rawData,
            titulo,
            tipo
        };
    };

    const obtenerFechasDeFiltro = (filtro, fechaSeleccionada, semanaSeleccionada, mesSeleccionado, anioSeleccionado) => {
        let fechaInicio, fechaFin;

        switch (filtro) {
            case "dia":
                const [year, month, day] = fechaSeleccionada.split('-').map(Number);
                fechaInicio = new Date(Date(year, month - 1, day));
                fechaFin = new Date(Date(year, month - 1, day + 1));
                break;
            case "semana":
                const [yearWeek, week] = semanaSeleccionada.split('-W').map(Number);
                fechaInicio = getFechaInicioSemanaISO(yearWeek, week);
                fechaFin = new Date(fechaInicio);
                fechaFin.setDate(fechaFin.getDate() + 6); // domingo
                /*
                const [yearWeek, week] = semanaSeleccionada.split('-W').map(Number);
                const primerDiaDelAnio = new Date(Date(yearWeek, 0, 1));
                const diaDeLaSemanaPrimerDia = primerDiaDelAnio.getDay();
                const ajusteAlLunes = diaDeLaSemanaPrimerDia === 0 ? 1 : 8 - diaDeLaSemanaPrimerDia;
                fechaInicio = new Date(Date(primerDiaDelAnio.getFullYear(), 0, 1 + ajusteAlLunes + (week - 1) * 7));
                fechaFin = new Date(fechaInicio);
                fechaFin.setDate(fechaFin.getDate() + 7);*/
                break;
            case "mes":
                const [mesAnio, mes] = mesSeleccionado.split('-').map(Number);
                fechaInicio = new Date(Date(mesAnio, mes - 1, 1));
                fechaFin = new Date(Date(mesAnio, mes, 1));
                break;
            case "año":
                const anio = parseInt(anioSeleccionado);
                fechaInicio = new Date(Date(anio, 0, 1));
                fechaFin = new Date(Date(anio + 1, 0, 1));
                break;
            default:
                fechaInicio = new Date();
                fechaFin = new Date();
                break;
        }

        if (fechaInicio && fechaFin) {
            return { fechaInicio: fechaInicio.toISOString(), fechaFin: fechaFin.toISOString() };
        } else {
            return { fechaInicio: null, fechaFin: null };
        }
    };

    function getFechaInicioSemanaISO(year, week) {
        const simple = new Date(year, 0, 1 + (week - 1) * 7);
        const dow = simple.getDay(); // 0 = domingo, 1 = lunes, ...
        const ISOday = dow === 0 ? 7 : dow; // convertir domingo a 7
        const fechaInicio = new Date(simple);
        fechaInicio.setDate(simple.getDate() - ISOday + 1); // ajustar al lunes
        return fechaInicio;
    }

    const fetchDatos = async () => {
        setCargando(true);
        try {
            const invernaderoId = localStorage.getItem("invernaderoId");
            const { url, titulo, tipo } = urls.find(u => u.url === sensorUrl);

            const paramsA = obtenerFechasDeFiltro(filtroA, fechaSeleccionadaA, semanaSeleccionadaA, mesSeleccionadoA, anioSeleccionadoA);
            const responseA = await AxiosPublico.get(url, { params: paramsA });

            const paramsB = obtenerFechasDeFiltro(filtroB, fechaSeleccionadaB, semanaSeleccionadaB, mesSeleccionadoB, anioSeleccionadoB);
            const responseB = await AxiosPublico.get(url, { params: paramsB });

            const datosFiltradosA = responseA.data.historiales.filter(item => item[`Sensor${tipo.charAt(0).toUpperCase() + tipo.slice(1)}.invernaderoId`] == invernaderoId);
            const datosFiltradosB = responseB.data.historiales.filter(item => item[`Sensor${tipo.charAt(0).toUpperCase() + tipo.slice(1)}.invernaderoId`] == invernaderoId);

            const gruposA = {};
            datosFiltradosA.forEach(item => {
                const sensorIdKey = Object.keys(item).find(key => key.includes('.id'));
                const sensorNombreKey = Object.keys(item).find(key => key.includes('.nombre'));

                const sensorId = item[sensorIdKey] ?? "desconocido";
                const sensorNombre = item[sensorNombreKey] ?? `Sensor ${sensorId}`;

                if (!gruposA[sensorId]) gruposA[sensorId] = { nombre: sensorNombre, datos: [] };
                gruposA[sensorId].datos.push(item);
            });

            const gruposB = {};
            datosFiltradosB.forEach(item => {
                const sensorIdKey = Object.keys(item).find(key => key.includes('.id'));
                const sensorNombreKey = Object.keys(item).find(key => key.includes('.nombre'));

                const sensorId = item[sensorIdKey] ?? "desconocido";
                const sensorNombre = item[sensorNombreKey] ?? `Sensor ${sensorId}`;

                if (!gruposB[sensorId]) gruposB[sensorId] = { nombre: sensorNombre, datos: [] };
                gruposB[sensorId].datos.push(item);
            });

            const nuevosDatos = Object.keys(gruposA).map(sensorId => {
                const sensorNombre = gruposA[sensorId].nombre;
                const datosGraficoA = formatearDatos(gruposA[sensorId].datos, `Período A - ${sensorNombre}`, coloresPorTipo[tipo], tipo, filtroA);
                const datosGraficoB = gruposB[sensorId] ? formatearDatos(gruposB[sensorId].datos, `Período B - ${sensorNombre}`, '#28a745', tipo, filtroB) : null;

                const datasets = datosGraficoB ? [...datosGraficoA.datasets, ...datosGraficoB.datasets] : datosGraficoA.datasets;
                const labels = datosGraficoA.labels;

                const resumenA = {
                    sensorId: sensorNombre,
                    promedio: datosGraficoA.raw.length > 0 ? datosGraficoA.raw.reduce((sum, val) => sum + val.valor, 0) / datosGraficoA.raw.length : null,
                    minimo: {
                        valor: datosGraficoA.raw.length > 0 ? Math.min(...datosGraficoA.raw.map(item => item.valor)) : null,
                        fechaHora: datosGraficoA.raw.length > 0 ? datosGraficoA.raw.find(item => item.valor === Math.min(...datosGraficoA.raw.map(d => d.valor)))?.fecha : null
                    },
                    maximo: {
                        valor: datosGraficoA.raw.length > 0 ? Math.max(...datosGraficoA.raw.map(item => item.valor)) : null,
                        fechaHora: datosGraficoA.raw.length > 0 ? datosGraficoA.raw.find(item => item.valor === Math.max(...datosGraficoA.raw.map(d => d.valor)))?.fecha : null
                    }
                };

                const resumenB = datosGraficoB ? {
                    sensorId: sensorNombre,
                    promedio: datosGraficoB.raw.length > 0 ? datosGraficoB.raw.reduce((sum, val) => sum + val.valor, 0) / datosGraficoB.raw.length : null,
                    minimo: {
                        valor: datosGraficoB.raw.length > 0 ? Math.min(...datosGraficoB.raw.map(item => item.valor)) : null,
                        fechaHora: datosGraficoB.raw.length > 0 ? datosGraficoB.raw.find(item => item.valor === Math.min(...datosGraficoB.raw.map(d => d.valor)))?.fecha : null
                    },
                    maximo: {
                        valor: datosGraficoB.raw.length > 0 ? Math.max(...datosGraficoB.raw.map(item => item.valor)) : null,
                        fechaHora: datosGraficoB.raw.length > 0 ? datosGraficoB.raw.find(item => item.valor === Math.max(...datosGraficoB.raw.map(d => d.valor)))?.fecha : null
                    }
                } : null;

                return {
                    titulo: `${titulo} - ${sensorNombre}`,
                    grafico: { labels, datasets, rawA: datosGraficoA.raw, rawB: datosGraficoB?.raw },
                    resumenA: resumenA,
                    resumenB: resumenB,
                };
            });

            setDataComparacion(nuevosDatos);
        } catch (error) {
            console.error("Error al obtener los datos:", error);
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => {
        setDataComparacion({});
        setFiltroA("dia");
        setFiltroB("dia");
        setFechaSeleccionadaA(new Date().toLocaleDateString('en-CA'));
        setFechaSeleccionadaB(new Date().toLocaleDateString('en-CA'));
        setSemanaSeleccionadaA("");
        setSemanaSeleccionadaB("");
        setMesSeleccionadoA(new Date().toISOString().slice(0, 7));
        setMesSeleccionadoB(new Date().toISOString().slice(0, 7));
        setAnioSeleccionadoA(new Date().getFullYear());
        setAnioSeleccionadoB(new Date().getFullYear());
    }, [sensorUrl]);

    const handleSensorChange = (e) => setSensorUrl(e.target.value);
    const handleFiltroAChange = (filtro) => {
        setFiltroA(filtro);
        setFiltroB(filtro);
    };

    const renderDateInputs = (filtro, fechaSeleccionada, setFechaSeleccionada, semanaSeleccionada, setSemanaSeleccionada, mesSeleccionado, setMesSeleccionado, anioSeleccionado, setAnioSeleccionado) => {
        switch (filtro) {
            case 'dia':
                return (
                    <div className="row mb-3 gx-2 px-2 align-items-center">
                        <div className="col-12 col-md-auto">
                            <label htmlFor="fechaSelect" className="form-label mb-0 fw-semibold">Fecha:</label>
                        </div>
                        <div className="col-12 col-sm">
                            <input
                                type="date"
                                id="fechaSelect"
                                className="form-control form-control-sm"
                                style={{ width: "70%" }}
                                value={fechaSeleccionada}
                                onChange={(e) => setFechaSeleccionada(e.target.value)}
                            />
                        </div>
                    </div>
                );
            case 'semana':
                return (
                    <div className="row mb-3 gx-2 px-2 align-items-center">
                        <div className="col-12 col-md-auto">
                            <label htmlFor="semanaSelect" className="form-label mb-0 fw-semibold">Semana:</label>
                        </div>
                        <div className="col-12 col-sm">
                            <input
                                type="week"
                                id="semanaSelect"
                                className="form-control form-control-sm"
                                style={{ width: "60%" }}
                                value={semanaSeleccionada}
                                onChange={(e) => setSemanaSeleccionada(e.target.value)}
                            />
                        </div>
                    </div>
                );
            case 'mes':
                return (
                    <div className="row mb-3 gx-2 px-2 align-items-center">
                        <div className="col-12 col-md-auto">
                            <label htmlFor="semanaSelect" className="form-label mb-0 fw-semibold">Mes:</label>
                        </div>
                        <div className="col-12 col-sm">
                            <input
                                type="month"
                                id="mesSelect"
                                className="form-control form-control-sm"
                                style={{ width: "60%" }}
                                value={mesSeleccionado}
                                onChange={(e) => setMesSeleccionado(e.target.value)}
                            />
                        </div>
                    </div>
                );
            case 'año':
                return (
                    <div className="row mb-3 gx-2 px-2 align-items-center">
                        <div className="col-12 col-md-auto">
                            <label htmlFor="anioSelect" className="form-label mb-0 fw-semibold">Año:</label>
                        </div>
                        <div className="col-12 col-sm">
                            <input
                                type="number"
                                id="anioSelect"
                                className="form-control form-control-sm"
                                style={{ width: "50%" }}
                                min="2000"
                                max={new Date().getFullYear()}
                                value={anioSeleccionado}
                                onChange={(e) => setAnioSeleccionado(e.target.value)}
                            />
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <Page datos={datosPagina}>
            <Card titulo="Comparación de Gráficas">
                <div className="row mb-4">
                    <div className="col-md-12">
                        <label htmlFor="sensorSelect" className="form-label fw-bold text-primary">Seleccionar Sensor</label>
                        <select className="form-select border border-secondary rounded shadow-sm mx-2" id="sensorSelect" value={sensorUrl} onChange={handleSensorChange}>
                            {urls.map(u => (
                                <option key={u.url} value={u.url}>{u.titulo}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 col-md-6 border-end">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3 gap-2 px-2">
                            <label className="form-label mb-0 fw-semibold text-nowrap">Filtro:</label>
                            <div className="d-grid d-md-flex flex-wrap gap-2 w-100">
                                <div className="d-grid d-md-flex gap-2 mb-2 mb-md-0">
                                    <button
                                        className={`btn btn-sm mx-1 ${filtroA === "dia" ? "btn-primary" : "btn-outline-primary"}`}
                                        onClick={() => handleFiltroAChange("dia")}>Día</button>
                                    <button
                                        className={`btn btn-sm mx-1 ${filtroA === "semana" ? "btn-primary" : "btn-outline-primary"}`}
                                        onClick={() => handleFiltroAChange("semana")}>Semana</button>
                                        <button
                                        className={`btn btn-sm mx-1 ${filtroA === "mes" ? "btn-primary" : "btn-outline-primary"}`}
                                        onClick={() => handleFiltroAChange("mes")}>Mes</button>
                                    <button
                                        className={`btn btn-sm mx-1 ${filtroA === "año" ? "btn-primary" : "btn-outline-primary"}`}
                                        onClick={() => handleFiltroAChange("año")}>Año</button>
                                </div>
                            </div>
                        </div>
                        <h6 className="text-center text-primary">Configuración del Período A</h6>
                        {renderDateInputs(filtroA, fechaSeleccionadaA, setFechaSeleccionadaA, semanaSeleccionadaA, setSemanaSeleccionadaA, mesSeleccionadoA, setMesSeleccionadoA, anioSeleccionadoA, setAnioSeleccionadoA)}
                    </div>

                    <div className="col-12 col-md-6">
                        <h6 className="text-center text-success">Configuración del Período B</h6>
                        {renderDateInputs(filtroB, fechaSeleccionadaB, setFechaSeleccionadaB, semanaSeleccionadaB, setSemanaSeleccionadaB, mesSeleccionadoB, setMesSeleccionadoB, anioSeleccionadoB, setAnioSeleccionadoB)}
                    </div>
                </div>

                <div className="d-grid my-4 px-2">
                    <button className="btn btn-primary btn-sm" onClick={fetchDatos}>
                        {cargando ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : "Comparar Gráficas"}
                    </button>
                </div>

                {cargando ? (
                    <div className="d-flex justify-content-center align-items-center flex-column py-5">
                        <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status"></div>
                    </div>
                ) : (
                    dataComparacion.length > 0 ? (
                        dataComparacion.map((comparacion, idx) => (
                            <div key={idx} className="mb-5">
                                <h5 className="text-center mb-4">{comparacion.titulo}</h5>
                                <Linea datos={comparacion.grafico} />
                                <div className="row mt-4">
                                    <div className="col-12 col-md-6">
                                        <h6 className="text-center text-primary">Tabla de Resumen - Período A</h6>
                                        <ResumenMinMax datos={comparacion.resumenA} filtro={filtroA} />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <h6 className="text-center text-success">Tabla de Resumen - Período B</h6>
                                        <ResumenMinMax datos={comparacion.resumenB} filtro={filtroB} />
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-center py-5">Selecciona un sensor y aplica los filtros para comenzar la comparación.</p>
                    )
                )}
            </Card>
        </Page>
    );
};

export default ComparacionGraficas;